import { useState } from "react";

export const useSessionCookie = (keyName: string, defaultValue: string | undefined): [string | undefined, (newValue: string | undefined) => void] => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      let value = RegExp(`(^|;) ?${keyName}=([^;]*)(;|$)`).exec(document.cookie)?.[0]?.split("=");
      if (value && value.length > 1) 
      {
        return value[1].replace(";", "");
      } else 
      {
        if(defaultValue){
          document.cookie = `${keyName}=${defaultValue}`;
        }else{
          document.cookie = `${keyName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
        }
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });
  const setCookieValue= (newValue: string | undefined) => {
    try {
      if (!newValue) {
        document.cookie = `${keyName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
      }else
      {
        document.cookie = `${keyName}=${newValue}`;
      }
    } catch (err) {
      console.log(err);
    }
    setStoredValue(newValue);
  };

  return [storedValue, setCookieValue];
};